import { Link } from "react-router-dom"
import styles from "./HStyle.module.css"

export const home = () => {
    return (
        <div className= {styles.main}>

            <div className={styles.header}>

                <div className={styles.headertop}>
                    <div className={styles.logo}></div>
                    <p id={styles.dir}>¡Conócenos! Los canelos 55 local 4 -  San pedro de la paz</p>
                </div>
                <div className={styles.headerbottom}>
                    <p id={styles.message}>Despachos con normalidad</p>
                </div>
            </div>
            
            <div className={styles.banner}>
                <div className={styles.contactdiv}>

                    <Link className={styles.Contactbtn} to="/contacto">
                        <button className={styles.CSinnerbtn}>Contacto</button>
                    </Link>

                </div> 

                <div className={styles.bannertxt}>
                    <h1>¡Hola!</h1>
                    <h2>Revisa nuestros servicios aquí ↓</h2>
                    
                    <Link className={styles.Servicebtn} to="/servicios">
                        <button  className={styles.CSinnerbtn}>Servicios</button>
                    </Link>
                </div>
            </div>


        </div>
    )
}
